import { Box, Grid } from "@material-ui/core";
import React from "react";

const searchInputStyle = {
  marginLeft: "12px",
  height: "32px",
  padding: "4px",
  border: "1px solid #ccc",
  borderRadius: "5px",
  width: "250px",
};

export default function WeeklyEACHeader({
  detailedViewRatesData,
  handleClickViewRates,
  searchLcat,
  setSearchLcat,
}) {
  if (!detailedViewRatesData || detailedViewRatesData.status !== 200) {
    return null;
  }

  const { year, fringe, oh, smAndH, gAndA } = detailedViewRatesData.data;

  return (
    <Grid container spacing={2} style={{ marginTop: "16px" }}>
      <Grid item lg={8}>
        <span
          style={{
            fontWeight: 600,
            color: "#09659c",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={handleClickViewRates}
        >
          View Rates
        </span>
        <input
          placeholder="Search by LCAT"
          value={searchLcat}
          onChange={(e) => setSearchLcat(e.target.value)}
          style={searchInputStyle}
        />
      </Grid>
      <Grid item lg={4}>
        <Box
          display="flex"
          flexDirection="row"
          style={{
            float: "right",
            border: "1px solid #6e6d6d",
            borderRadius: "5px",
            height: "48px",
          }}
        >
          <Box
            style={{
              width: "200px",
              fontWeight: 600,
              textAlign: "center",
              alignContent: "center",
              borderRight: "1px solid #6e6d6d",
            }}
          >
            {year} Forecasted Rates
          </Box>
          <Box style={{ width: "72px", textAlign: "center", alignContent: "center" }}>
            <div>Fringe</div>
            <div>{fringe}%</div>
          </Box>
          <Box style={{ width: "72px", textAlign: "center", alignContent: "center" }}>
            <div>OH</div>
            <div>{oh}%</div>
          </Box>
          <Box style={{ width: "72px", textAlign: "center", alignContent: "center" }}>
            <div>SM&H</div>
            <div>{smAndH}%</div>
          </Box>
          <Box style={{ width: "72px", textAlign: "center", alignContent: "center" }}>
            <div>G&A</div>
            <div>{gAndA}%</div>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
